import React, { useEffect } from "react";
import ClientesTemplate from "../components/templates/ClientesTemplate";
import { useSession } from "../context/SessionContext";
import { useNavigate } from "react-router-dom";

const Clientes = () => {
    const { user } = useSession();
    const navigate = useNavigate();

    useEffect(() => {
        if (user && user.role !== "Admin" && user.role !== "Lawyer") {
            navigate("/dashboard");
        }
    }, [user, navigate]);

    if (!user || (user.role !== "Admin" && user.role !== "Lawyer")) {
        return null;
    }

    return <ClientesTemplate />;
};

export default Clientes;